import { Dialog } from "@radix-ui/themes";
import { QueryStatus } from "@reduxjs/toolkit/query";
import { CheckoutFailed } from "./checkout-failed";
import { CheckoutPending } from "./checkout-pending";
import { CheckoutSuccessful } from "./checkout-success";

type CheckoutModalProps = {
  open: boolean;
  status: QueryStatus;
  errorMessage: string | undefined;
  amount?: string;
  setOpen: (value: boolean) => void;
};

export function CheckoutModal({
  open,
  amount,
  status,
  setOpen,
  errorMessage,
}: CheckoutModalProps) {
  return (
    <Dialog.Root open={open}>
      <Dialog.Content
        style={{ maxWidth: 540, borderRadius: 32, height: 500 }}
        className="mobile-fa"
      >
        {status === QueryStatus.fulfilled ? (
          <CheckoutSuccessful
            onPrintReceipt={console.log}
            amount={amount}
            onClose={() => {
              setOpen(false);
            }}
          />
        ) : status === QueryStatus.rejected ? (
          <CheckoutFailed
            errorMessage={errorMessage}
            onRetry={() => {
              setOpen(false);
            }}
            onClose={() => {
              setOpen(false);
            }}
          />
        ) : (
          <CheckoutPending />
        )}
      </Dialog.Content>
    </Dialog.Root>
  );
}
